export const privacyText = { privacyBody: 'This is my privacy policy' }
